/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"
import Slider from "react-slick"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import "./slider.css"
import { CENTRAL_DASHBOARD_API } from "../../../../constant/config"
import { Link, useHistory } from "react-router-dom"

const BannerSlider = ({ banners }) => {
  const settings = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    centerMode: true,
    centerPadding: "0",
    draggable: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  const history = useHistory()

  const headerMenu = [
    "/all-inventory",
    "/my-inventory",
    "/my-orders",
    "/marketing-material",
    "/my-account",
    "/help",
    "/return",
    "/trunkey",
    "/upgrade-save",
    "/help-sold-out-product"
  ]

  // check shop exist or not
  const path = window.location.href.replace(/^.+\?/i, "")
  const searchParams = new URLSearchParams(path)
  const shop = searchParams.get("shop")
  const host = searchParams.get("host")

  const checkRedirection = (e, path) => {
    if (path === "#") {
      e.preventDefault()
    } else {
      if (headerMenu.includes(path)) {
        history.push(`${path}?shop=${shop}&host=${host}`)
      } else {
        window.open(path, "_blank")
      }
    }
  }

  return (
    <>
      {banners && banners.length > 0 && (
        <div className="main_banner">
          <Slider className="center slider" {...settings}>
            {banners?.map((banner, index) => (
              <div key={index}>
                <a
                  to={void 0}
                  onClick={(e) => checkRedirection(e, banner?.slug)}
                >
                  <img
                    src={`${toAbsoluteUrl(
                      `${CENTRAL_DASHBOARD_API}uploads/banners/${banner.banner_image}`
                    )}`}
                    alt={banner.banner_image}
                  />
                </a>
              </div>
            ))}
            {/* Rest of the slider items */}
          </Slider>
        </div>
      )}
      {/* Rest of the code */}
    </>
  )
}

export default BannerSlider
